import { DismissablePromptKey, Experiment } from '@ms/yammer-data/dist/state/types';
import { useShouldStartDismissablePrompt } from '@ms/yammer-hooks/dist/dismissablePrompts';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';
import { useCurrentSessionUser } from '@ms/yammer-hooks/dist/session';

export const useShouldDisplayVivaEngageAdminRebrandingBanner = () => {
  const { isNetworkAdmin } = useCurrentSessionUser();

  const isAdminBannerExperimentEnabled =
    useExperimentTreatmentWithoutReporting(Experiment.VivaEngageRebrandingAdminBanner) === 'enabled';
  const shouldStartAdminBannerPrompt = useShouldStartDismissablePrompt(
    DismissablePromptKey.VivaEngageRebrandingAdminBanner
  );

  const isRebrandingAlreadyEnabled = !!useExperimentTreatmentWithoutReporting(Experiment.VivaEngageRebranding);

  if (isRebrandingAlreadyEnabled) {
    return false;
  }

  return isAdminBannerExperimentEnabled && isNetworkAdmin && shouldStartAdminBannerPrompt;
};
